import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { v4 as uuid } from 'uuid';
import DOMPurify from 'dompurify';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { DataGrid } from '@mui/x-data-grid';
import { dateToFormat } from 'src/utils/date';
import { useTranslation } from 'react-i18next';
// import { EditFeesModal } from './EditFeesModal';
import React, { useEffect, useState } from 'react';
import { DismissRefundModal } from './DismissRefundModal';
import { CompaniesSelector } from './CompaniesSelectorComponent';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { RefundCreditInvoiceModal } from './RefundCreditInvoiceModal';
import { capitalizeFirstLetter } from 'src/utils/capitalizeFirstLetter';
import { Button, Chip, Link, Tab, Tabs, Typography } from '@mui/material';
import { PaymentsAndSubscriptionsMenu } from './PaymentsAndSubscriptionsMenu';
import { BackdropLoader, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
export const PaymentsAndSubscriptionsContent = observer(_ref => {
  var _store$homeDashboardS, _store$payment$getCur, _store$payment$getCur2, _store$payment$getCur3, _store$payment$getCur4, _store$payment$getCur5, _store$payment$getCur6, _store$payment$getCur7, _store$payment$getCur8, _store$payment$getCur0, _store$payment$getCur1, _store$payment$getCur10, _store$payment$getCur11, _store$payment$getCur12, _store$payment$getCur13, _store$payment$getCur14, _store$payment$getCur15, _store$payment$getCur16, _store$payment$getCur17, _store$payment$getCur18, _store$payment$getCur19, _store$payment$getCur20, _store$payment$getCur21, _store$payment$getCur22, _store$payment$getCur23, _store$payment$getCur24, _store$payment$getCur25, _store$payment$getCur26, _store$payment$getCur27, _store$payment$getCur28, _store$payment$getCur29, _store$payment$getCur30, _store$payment$getCur31, _store$payment$getCur32, _store$payment$getCur33, _store$payment$getCur34, _store$payment$getCur35, _store$payment$getCur36, _store$payment$getCur37, _store$payment$getCur38, _store$payment$getCur39, _store$payment$getCur40, _store$payment$getCur41;
  let handleOpenCreateAccountModal = _ref.handleOpenCreateAccountModal;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const reasonList = {
    BillingErrorUtility: 'Billing Error - Utility',
    BillingErrorFee: 'Billing Error - Fee',
    Overcharge: 'Overcharge',
    ServiceNotRendered: 'Service Not Rendered',
    ClientDispute: 'Client Dispute',
    LateFeeWaived: 'Late Fee Waived',
    StatementIssue: 'USPS statement Issue',
    UnitVacant: 'Unit Vacant',
    PromotionalCredit: 'Promotional Credit',
    Other: 'Other'
  };
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currentSubsId = _useState2[0],
    setCurrentSubsId = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    showInvoice = _useState4[0],
    setShowInvoice = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    modalInvoice = _useState6[0],
    setModalInvoice = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showRefundCreditInvoiceModal = _useState8[0],
    setShowRefundCreditInvoiceModal = _useState8[1];
  const _useState9 = useState('subscriptions'),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedTab = _useState0[0],
    setSelectedTab = _useState0[1];
  const handleTabChange = async (e, value) => {
    setSelectedTab(value);
  };
  const _useState1 = useState('details'),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedSubTab = _useState10[0],
    setSelectedSubTab = _useState10[1];
  const handleSubTabChange = async (e, value) => {
    setSelectedSubTab(value);
  };
  const _useState11 = useState('create'),
    _useState12 = _slicedToArray(_useState11, 2),
    billingAutomationSetupModalStatesDemo = _useState12[0],
    setBillingAutomationSetupModalStatesDemo = _useState12[1]; // NOTE: for demo purposes statuses - create | activate | activated

  useEffect(() => {
    setSelectedTab('subscriptions');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id]);
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const fetchData = async () => {
    var _resp$response;
    const resp = await store.payment.getStripeSubscriptionAsync.run();
    if (resp !== null && resp !== void 0 && (_resp$response = resp.response) !== null && _resp$response !== void 0 && _resp$response[0]) setCurrentSubsId(resp.response[0].subscriptionId);
    await store.payment.getStripeInvoiceAsync.run();
  };
  const Cell = _ref2 => {
    let value = _ref2.value,
      _ref2$isStatus = _ref2.isStatus,
      isStatus = _ref2$isStatus === void 0 ? false : _ref2$isStatus,
      _ref2$forInvoice = _ref2.forInvoice,
      forInvoice = _ref2$forInvoice === void 0 ? false : _ref2$forInvoice;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isStatus && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: forInvoice ? "".concat(forInvoice, " for invoice: ").concat(!value ? 'N/A' : value) : value,
      placement: "top"
    }, !forInvoice && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(!value ? 'disabled' : '')
    }, !value ? 'N/A' : value), forInvoice && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(!value ? 'disabled' : '')
    }, forInvoice, " for invoice:", ' ', /*#__PURE__*/React.createElement("span", {
      role: "button",
      className: classes.refundLink,
      onClick: event => {
        var _store$payment$stripe;
        event.stopPropagation();
        setShowInvoice((_store$payment$stripe = store.payment.stripeInvoices.find(i => i.type !== 'Refund' && i.type !== 'Credit' && i.invoiceNumber === value)) === null || _store$payment$stripe === void 0 ? void 0 : _store$payment$stripe.id);
      },
      onKeyDown: event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopPropagation();
        }
      },
      tabIndex: 0
    }, !value ? 'N/A' : value))), isStatus && /*#__PURE__*/React.createElement(Chip, {
      label: capitalizeFirstLetter(value),
      variant: value === 'Failed' ? 'critical' : value === 'Processing' ? 'inactive' : value === 'Upcoming' ? 'info' : 'success'
    }));
  };
  const ActionCell = _ref3 => {
    let _ref3$isDismissRefund = _ref3.isDismissRefund,
      isDismissRefund = _ref3$isDismissRefund === void 0 ? false : _ref3$isDismissRefund,
      stripeInvoiceId = _ref3.stripeInvoiceId,
      invoiceLink = _ref3.invoiceLink,
      _ref3$isDisabledRefun = _ref3.isDisabledRefund,
      isDisabledRefund = _ref3$isDisabledRefun === void 0 ? false : _ref3$isDisabledRefun,
      _ref3$isDisabledInvoi = _ref3.isDisabledInvoice,
      isDisabledInvoice = _ref3$isDisabledInvoi === void 0 ? false : _ref3$isDisabledInvoi,
      _ref3$isAdjustmentHis = _ref3.isAdjustmentHistory,
      isAdjustmentHistory = _ref3$isAdjustmentHis === void 0 ? false : _ref3$isAdjustmentHis,
      stripeRefundId = _ref3.stripeRefundId;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isDismissRefund && /*#__PURE__*/React.createElement(DismissRefundModal, {
      reloadData: fetchData,
      stripeRefundId: stripeRefundId
    }), !isDismissRefund && !isAdjustmentHistory && /*#__PURE__*/React.createElement(PaymentsAndSubscriptionsMenu, {
      handleOpenRefundCreditInvoiceModal: () => setShowRefundCreditInvoiceModal(true),
      setModalInvoice: () => setModalInvoice(stripeInvoiceId),
      invoiceLink: invoiceLink,
      isDisabledRefund: isDisabledRefund,
      isDisabledInvoice: isDisabledInvoice
    }));
  };
  let columns = [{
    field: 'invoice',
    align: 'left',
    width: 130,
    valueGetter: params => params.row.type === 'Refund' || params.row.type === 'Credit' ? null : params.row.invoiceNumber,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.type === 'Refund' || params.row.type === 'Credit' ? null : params.row.invoiceNumber
    }),
    renderHeader: () => renderHeader(t('Invoice'))
  }, {
    field: 'type',
    align: 'left',
    width: 70,
    valueGetter: params => params.row.type,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.type
    }),
    renderHeader: () => renderHeader(t('Type'))
  }, {
    field: 'description',
    align: 'left',
    flex: 1,
    minWidth: 220,
    maxWidth: 1000,
    valueGetter: params => params.row.type === 'Refund' || params.row.type === 'Credit' ? "".concat(params.row.type === 'Refund' ? 'Refund' : 'Credit', " for invoice: ").concat(params.row.invoiceNumber) : params.row.description,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      forInvoice: params.row.type === 'Refund' ? 'Refund' : params.row.type === 'Credit' ? 'Credit' : false,
      value: params.row.type === 'Refund' || params.row.type === 'Credit' ? params.row.invoiceNumber : params.row.description
    }),
    renderHeader: () => renderHeader(t('Description'))
  }, {
    field: 'paymentMethod',
    align: 'left',
    flex: 1,
    minWidth: 120,
    maxWidth: 180,
    valueGetter: params => params.row.brand && params.row.last4 ? "".concat(capitalizeFirstLetter(params.row.brand), " \u2022\u2022\u2022\u2022 ").concat(params.row.last4) : null,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.brand && params.row.last4 ? "".concat(capitalizeFirstLetter(params.row.brand), " \u2022\u2022\u2022\u2022 ").concat(params.row.last4) : null
    }),
    renderHeader: () => renderHeader(t('Payment method'))
  }, {
    field: 'status',
    align: 'left',
    width: 100,
    valueGetter: params => params.row.status,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.status,
      isStatus: true
    }),
    renderHeader: () => renderHeader(t('Status'))
  }, {
    field: 'date',
    align: 'left',
    width: 100,
    valueGetter: params => params.row.paidAt,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: dateToFormat(params.row.paidAt)
    }),
    renderHeader: () => renderHeader(t('Date'))
  }, {
    field: 'originalAmount',
    align: 'left',
    width: 90,
    valueGetter: params => params.row.amount,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: "$".concat(params.row.amount)
    }),
    renderHeader: () => renderHeader(t('Original Amount'))
  }, {
    field: 'Adjustments',
    align: 'left',
    width: 100,
    valueGetter: params => params.row.type === 'Refund' || params.row.type === 'Credit' ? null : params.row.adjustments,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.type === 'Refund' || params.row.type === 'Credit' ? null : "$".concat(params.row.adjustments)
    }),
    renderHeader: () => renderHeader(t('Adjustments'))
  }, {
    field: 'remainingBalance',
    align: 'left',
    width: 90,
    valueGetter: params => params.row.type === 'Refund' || params.row.type === 'Credit' ? null : params.row.remainingBalance,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.type === 'Refund' || params.row.type === 'Credit' ? null : "$".concat(params.row.remainingBalance)
    }),
    renderHeader: () => renderHeader(t('Remaining Balance'))
  }, {
    field: 'actions',
    align: 'left',
    width: 63,
    renderCell: params => /*#__PURE__*/React.createElement(ActionCell, {
      isDismissRefund: params.row.status === 'Processing',
      invoiceLink: params.row.invoiceLink,
      stripeInvoiceId: params.row.id,
      isDisabledInvoice: params.row.status === 'Upcoming',
      stripeRefundId: params.row.stripeRefundId,
      isDisabledRefund: params.row.status === 'Failed' || params.row.status === 'Upcoming' || params.row.status === 'Processing' || params.row.type === 'Refund' || params.row.type === 'Credit'
    }),
    renderHeader: () => renderHeader(t(''))
  }];
  let refundColumns = [{
    field: 'paymentMethod',
    align: 'left',
    flex: 1,
    minWidth: 200,
    maxWidth: 250,
    valueGetter: params => params.row.brand && params.row.last4 ? "".concat(capitalizeFirstLetter(params.row.brand), " \u2022\u2022\u2022\u2022 ").concat(params.row.last4) : null,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.brand && params.row.last4 ? "".concat(capitalizeFirstLetter(params.row.brand), " \u2022\u2022\u2022\u2022 ").concat(params.row.last4) : null
    }),
    renderHeader: () => renderHeader(t('Payment method'))
  }, {
    field: 'date',
    align: 'left',
    width: 100,
    valueGetter: params => params.row.dateTime,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: dateToFormat(params.row.dateTime)
    }),
    renderHeader: () => renderHeader(t('Date'))
  }, {
    field: 'status',
    align: 'left',
    width: 100,
    valueGetter: params => params.row.status,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.status,
      isStatus: true
    }),
    renderHeader: () => renderHeader(t('Status'))
  }, {
    field: 'comment',
    align: 'left',
    flex: 1,
    maxWidth: 500,
    minWidth: 120,
    valueGetter: params => params.row.comment,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.comment
    }),
    renderHeader: () => renderHeader(t('Comment'))
  }, {
    field: 'amount',
    align: 'left',
    width: 90,
    valueGetter: params => params.row.amount,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: "$".concat(params.row.amount)
    }),
    renderHeader: () => renderHeader(t('Amount'))
  }, {
    field: 'refundCreditReason',
    align: 'left',
    flex: 1,
    maxWidth: 500,
    minWidth: 120,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: reasonList[params.row.refundCreditReason]
    }),
    renderHeader: () => renderHeader(t('Refund/Credit reason'))
  }, {
    field: 'actions',
    align: 'left',
    width: 63,
    renderCell: params => /*#__PURE__*/React.createElement(ActionCell, {
      isDismissRefund: params.row.status === 'Processing',
      isAdjustmentHistory: true,
      stripeRefundId: params.row.stripeRefundId
    }),
    renderHeader: () => renderHeader(t(''))
  }];
  const handleCellClick = params => {
    if (params.field !== 'actions') {
      setShowInvoice(params.row.id);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationPage
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getStripeSubscriptionAsync.inProgress || store.payment.getStripeInvoiceAsync.inProgress
  }), /*#__PURE__*/React.createElement(RefundCreditInvoiceModal, {
    currentInvoice: modalInvoice,
    reloadData: fetchData,
    setShowInvoice: setShowInvoice,
    isOpen: showRefundCreditInvoiceModal,
    handleOpenExternal: () => setShowRefundCreditInvoiceModal(true),
    handleCloseExternal: () => {
      setModalInvoice(null);
      setShowRefundCreditInvoiceModal(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationPageContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationContent
  }, (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement("div", {
    className: classes.allocationNav
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationNavPortfolios
  }, /*#__PURE__*/React.createElement(CompaniesSelector, {
    handleOpenCreateAccountModal: handleOpenCreateAccountModal
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.allocationBody, " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarningBoth' : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarning' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscription
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionHeaderTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h3'
  }, "Payments & subscriptions")), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionHeaderTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    onChange: handleTabChange,
    value: selectedTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: t('Subscriptions'),
    value: 'subscriptions'
  }), /*#__PURE__*/React.createElement(Tab, {
    label: t('Payment info'),
    value: 'paymentInfo',
    disabled: true
  }), /*#__PURE__*/React.createElement(Tab, {
    label: t('Reimbursement info'),
    value: 'reimbursementInfo',
    disabled: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionLsit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionUnits
  }, store.payment.stripeSubscriptionUnits.map(i => /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.paymentAndSubscriptionUnit, " ").concat(currentSubsId === i.subscriptionId ? 'active' : ''),
    key: i.subscriptionId,
    onClick: () => {
      setCurrentSubsId(i.subscriptionId);
      setShowInvoice(null);
    }
  }, /*#__PURE__*/React.createElement("b", null, i.subscriptionName), /*#__PURE__*/React.createElement("span", null, capitalizeFirstLetter(i.brand), " \u2022\u2022\u2022\u2022 ", i.last4))))), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionDetailsHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionDetailsHeaderDetails
  }, /*#__PURE__*/React.createElement("b", null, (_store$payment$getCur = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur === void 0 ? void 0 : _store$payment$getCur.subscriptionName), /*#__PURE__*/React.createElement("span", null, (_store$payment$getCur2 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur2 === void 0 ? void 0 : _store$payment$getCur2.propertiesCount, " properties,", ' ', (_store$payment$getCur3 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur3 === void 0 ? void 0 : _store$payment$getCur3.unitsCount, " units,", ' ', capitalizeFirstLetter((_store$payment$getCur4 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur4 === void 0 ? void 0 : _store$payment$getCur4.brand), ' ', "\u2022\u2022\u2022\u2022 ", (_store$payment$getCur5 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur5 === void 0 ? void 0 : _store$payment$getCur5.last4)), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionDetailsHeaderTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    onChange: handleSubTabChange,
    value: selectedSubTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: t('Details'),
    value: 'details'
  }), /*#__PURE__*/React.createElement(Tab, {
    label: t('Transactions'),
    value: 'transactions'
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentAndSubscriptionDetailsBody
  }, selectedSubTab === 'details' && /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceDetailsWrapper
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('Subscription details')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceDetailsBoxTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Properties'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceDetailBox, " large")
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Property"), /*#__PURE__*/React.createElement("td", null, "Units"), /*#__PURE__*/React.createElement("td", null)), (_store$payment$getCur6 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur6 === void 0 ? void 0 : _store$payment$getCur6.properties.map(i => /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, i.propertyName), /*#__PURE__*/React.createElement("td", null, i.unitsCount)))), /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Total properties:", ' ', (_store$payment$getCur7 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur7 === void 0 ? void 0 : _store$payment$getCur7.propertiesCount), /*#__PURE__*/React.createElement("td", null, "Total units:", ' ', (_store$payment$getCur8 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur8 === void 0 ? void 0 : _store$payment$getCur8.unitsCount), /*#__PURE__*/React.createElement("td", null))))), /*#__PURE__*/React.createElement("br", null)), selectedSubTab === 'transactions' && /*#__PURE__*/React.createElement(React.Fragment, null, store.payment.stripeInvoices.length > 0 && !store.payment.getStripeSubscriptionAsync.inProgress && !store.payment.getStripeInvoiceAsync.inProgress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataGrid, {
    hideFooter: true,
    getRowId: () => uuid(),
    rows: store.payment.stripeInvoices.filter(r => {
      var _store$payment$getCur9;
      return r.stripeSubscriptionId === ((_store$payment$getCur9 = store.payment.getCurrentStripeSubscription(currentSubsId)) === null || _store$payment$getCur9 === void 0 ? void 0 : _store$payment$getCur9.stripeSubscriptionId);
    }),
    columns: columns,
    disableRowSelectionOnClick: true,
    columnHeaderHeight: 60,
    rowHeight: 60,
    onCellClick: handleCellClick
  })), showInvoice && /*#__PURE__*/React.createElement("div", {
    className: classes.invoice
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceHeaderAction
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      setShowInvoice(null);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceHeaderDetails
  }, /*#__PURE__*/React.createElement("b", null, "Invoice: ", (_store$payment$getCur0 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur0 === void 0 ? void 0 : _store$payment$getCur0.invoiceNumber), /*#__PURE__*/React.createElement("span", null, "Charge for subscription:", ' ', (_store$payment$getCur1 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur1 !== void 0 && _store$payment$getCur1.paidAt ? dateToFormat((_store$payment$getCur10 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur10 === void 0 ? void 0 : _store$payment$getCur10.paidAt) : 'N/A'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBodyHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBodyHeaderTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('Invoice details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBodyHeaderActions
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: (_store$payment$getCur11 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur11 === void 0 ? void 0 : _store$payment$getCur11.invoiceLink,
    target: "_blank",
    variant: "actionButton",
    disabled: ((_store$payment$getCur12 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur12 === void 0 ? void 0 : _store$payment$getCur12.status) === 'Upcoming' || !((_store$payment$getCur13 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur13 !== void 0 && _store$payment$getCur13.invoiceLink)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Download invoice'))), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(Button, {
    className: classes.lightTrigger,
    onClick: () => {
      setModalInvoice(showInvoice);
      setShowRefundCreditInvoiceModal(true);
    },
    variant: "actionButton",
    disabled: ((_store$payment$getCur14 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur14 === void 0 ? void 0 : _store$payment$getCur14.status) === 'Failed' || ((_store$payment$getCur15 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur15 === void 0 ? void 0 : _store$payment$getCur15.status) === 'Upcoming' || ((_store$payment$getCur16 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur16 === void 0 ? void 0 : _store$payment$getCur16.status) === 'Processing' || ((_store$payment$getCur17 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur17 === void 0 ? void 0 : _store$payment$getCur17.type) === 'Refund' || ((_store$payment$getCur18 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur18 === void 0 ? void 0 : _store$payment$getCur18.type) === 'Credit'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "auto-pay"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Refund/Credit'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceDetails
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Invoice number:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur19 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur19 === void 0 ? void 0 : _store$payment$getCur19.invoiceNumber), /*#__PURE__*/React.createElement("td", null, "Original Amount:"), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur20 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur20 === void 0 ? void 0 : _store$payment$getCur20.amount)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Type:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur21 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur21 === void 0 ? void 0 : _store$payment$getCur21.type), /*#__PURE__*/React.createElement("td", null, "Status:"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Chip, {
    label: capitalizeFirstLetter((_store$payment$getCur22 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur22 === void 0 ? void 0 : _store$payment$getCur22.status),
    variant: ((_store$payment$getCur23 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur23 === void 0 ? void 0 : _store$payment$getCur23.status) === 'Failed' ? 'critical' : ((_store$payment$getCur24 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur24 === void 0 ? void 0 : _store$payment$getCur24.status) === 'Processing' ? 'inactive' : ((_store$payment$getCur25 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur25 === void 0 ? void 0 : _store$payment$getCur25.status) === 'Upcoming' ? 'info' : 'success'
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Description:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur26 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur26 !== void 0 && _store$payment$getCur26.description ? (_store$payment$getCur27 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur27 === void 0 ? void 0 : _store$payment$getCur27.description : 'N/A'), /*#__PURE__*/React.createElement("td", null, "Adjustments:"), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur28 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur28 === void 0 ? void 0 : _store$payment$getCur28.amountPaid)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Payment method:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur29 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur29 !== void 0 && _store$payment$getCur29.brand && (_store$payment$getCur30 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur30 !== void 0 && _store$payment$getCur30.last4 ? "".concat(capitalizeFirstLetter((_store$payment$getCur31 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur31 === void 0 ? void 0 : _store$payment$getCur31.brand), " \u2022\u2022\u2022\u2022 ").concat((_store$payment$getCur32 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur32 === void 0 ? void 0 : _store$payment$getCur32.last4) : 'N/A'), /*#__PURE__*/React.createElement("td", null, "Remaining Balance:"), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur33 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur33 === void 0 ? void 0 : _store$payment$getCur33.remainingAmount)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Date:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur34 = store.payment.getCurrentStripeInvoices(showInvoice)) !== null && _store$payment$getCur34 !== void 0 && _store$payment$getCur34.paidAt ? dateToFormat((_store$payment$getCur35 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur35 === void 0 ? void 0 : _store$payment$getCur35.paidAt) : 'N/A'), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBlockTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Line items'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceTotal
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Line item"), /*#__PURE__*/React.createElement("td", null, "Price x 1"), /*#__PURE__*/React.createElement("td", null, "Count"), /*#__PURE__*/React.createElement("td", null, "Original amount"), /*#__PURE__*/React.createElement("td", null, "Refunded"), /*#__PURE__*/React.createElement("td", null, "Credited"))), /*#__PURE__*/React.createElement("tbody", null, (_store$payment$getCur36 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur36 === void 0 || (_store$payment$getCur36 = _store$payment$getCur36.lineItems) === null || _store$payment$getCur36 === void 0 ? void 0 : _store$payment$getCur36.map(i => /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, i.productName), /*#__PURE__*/React.createElement("td", null, "$", i.price), /*#__PURE__*/React.createElement("td", null, i.quantity), /*#__PURE__*/React.createElement("td", null, "$", i.amountPaid), /*#__PURE__*/React.createElement("td", null, "$", i.refunded), /*#__PURE__*/React.createElement("td", null, "$", i.credit))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Total"), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur37 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur37 === void 0 ? void 0 : _store$payment$getCur37.lineItems.reduce((accumulator, currentValue) => accumulator + currentValue.amountPaid, 0)), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur38 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur38 === void 0 ? void 0 : _store$payment$getCur38.lineItems.reduce((accumulator, currentValue) => accumulator + currentValue.refunded, 0)), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur39 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur39 === void 0 ? void 0 : _store$payment$getCur39.lineItems.reduce((accumulator, currentValue) => accumulator + currentValue.credit, 0)))))), ((_store$payment$getCur40 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur40 === void 0 || (_store$payment$getCur40 = _store$payment$getCur40.refundHistory) === null || _store$payment$getCur40 === void 0 ? void 0 : _store$payment$getCur40.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceBlockTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Adjustment history'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceRefund
  }, /*#__PURE__*/React.createElement(DataGrid, {
    hideFooter: true,
    getRowId: () => uuid(),
    rows: (_store$payment$getCur41 = store.payment.getCurrentStripeInvoices(showInvoice)) === null || _store$payment$getCur41 === void 0 ? void 0 : _store$payment$getCur41.refundHistory,
    columns: refundColumns,
    disableRowSelectionOnClick: true,
    columnHeaderHeight: 60,
    rowHeight: 60,
    onCellClick: handleCellClick
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))))))))))))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: 'Billing-Automation-Setup-Confirmation',
    headerText: t('add_new_property_flow.auto_billing_activation_modal_title'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.auto_billing_activation_modal_alert_title')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(t('add_new_property_flow.auto_billing_activation_modal_alert_content'))
      }
    })),
    externalIsOpen: billingAutomationSetupModalStatesDemo === 'activate',
    callBack: _ref4 => {
      let action = _ref4.action,
        objectToPassOver = _ref4.objectToPassOver;
      console.log('Billing-Automation-Setup-Confirmation', {
        action,
        objectToPassOver
      });
      if (action === 'cancel') {
        setBillingAutomationSetupModalStatesDemo('create');
      }
      if (action === 'submit') {
        setBillingAutomationSetupModalStatesDemo('activated');
      }
    },
    objectToPassOver: {
      test: 'Test value'
    },
    customTrigger: null
  })));
});